module.exports = __webpack_public_path__ + "img/slash-circle.5af68570.svg";